// extracted by mini-css-extract-plugin
export default {"VideoItemSkeleton":"VideoItemSkeleton_VideoItemSkeleton__x0c19","Loading":"VideoItemSkeleton_Loading__q9Txs","load":"VideoItemSkeleton_load__SZciZ"};